import { useEffect, useMemo, useState } from 'react'
import { ModalObjectProps } from '../../types'
import { useModals, useUser } from '../../store'
import { useActions } from '../../providers'
import { Button } from '../elements/Button'
import { HighlightLogo } from '@highlight/ui'
import { ArrowLeft } from 'lucide-react'
export const LoginModal: React.FC<ModalObjectProps> = ({ id, context }) => {
  const { closeModal, openModal } = useModals()
  const user = useUser()
  const { onLogin } = useActions()

  const isLoggedInSupabaseUser = useMemo(() => {
    return user?.provider === 'supabase' && !user?.isAnonymous
  }, [user])

  const message = useMemo(() => {
    if (context?.message) {
      return context.message
    }

    return 'Sign in to continue'
  }, [context])

  const onClickLogin = () => {
    window.ampltd.trackEvent('Auth', {
      action: 'Sign in',
      source: 'Login modal',
      authenticationStep: 'Open login page',
      isLoggedInSupabaseUser,
      message,
    })

    onLogin()
  }

  const onBack = () => {
    window.ampltd.trackEvent('Auth', {
      action: 'Back',
      source: 'Login modal',
      isLoggedInSupabaseUser,
    })

    closeModal(id)
  }

  useEffect(() => {
    if (user && user.provider === 'workos') {
      closeModal(id)
    }
  }, [user])

  return (
    <div
      className="bg-secondary-old fixed left-0 top-0 z-30 flex h-full min-h-fit w-full flex-col items-center gap-8 rounded-3xl pb-10 pt-11"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="text-light-40 absolute left-4 top-4 cursor-pointer" onClick={onBack}>
        <ArrowLeft size={24} />
      </div>
      <HighlightLogo size={40} tone="light" aria-hidden>
        <HighlightLogo.Icon />
      </HighlightLogo>
      <>
        <div className="text-light-90 text-[20px]">{message}</div>
        <div className="flex w-[263px] flex-col gap-6">
          <Button variant="yellow" size="xround" onClick={onClickLogin}>
            Sign In
          </Button>
        </div>
      </>
    </div>
  )
}
